import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const TreeTableCard = styled.div`
	color: ${colors.greyscale.darker_grey};
	font-size: 16px;

	.p-manager-table {
		box-shadow: none !important;
	}

	.p-treetable .p-treetable-thead > tr > th {
		background: white;
		font-size: 14px;
		color: ${colors.greyscale.darker_grey};
		padding: 0.2rem 2rem;
		font-weight: bold;
		outline-width: 5px;
	}

	.p-treetable .p-treetable-thead .pi {
		font-size: 12px;
	}

	.p-treetable .p-treetable-tbody > tr {
		background: ${colors.mainColors.white_lilac};
		margin-bottom: 5px;
		box-shadow: 5px 0px 0px 0px ${colors.greyscale.dark_grey} inset;
		cursor: default;
	}

	.p-treetable .p-treetable-tbody > tr > td {
		border: 2px solid #fff !important;
		border-width: 0 0 2px 0 !important;
		padding: 0.3rem 1rem;
	}

	.p-treetable .p-treetable-tbody .pi {
		font-weight: bold;
	}

	.p-discipline {
		box-shadow: 5px 0px 0px 0px ${colors.mainColors.blueberry} inset !important;
	}

	.p-item {
		box-shadow: 5px 0px 0px 0px ${colors.mainColors.verde_dstore} inset !important;
	}

	.p-theme {
		box-shadow: 5px 0px 0px 0px ${colors.mainColors.roxo_delinea} inset !important;
	}

	.p-media {
		box-shadow: 5px 0px 0px 0px ${colors.mainColors.capri} inset !important;
	}

	.p-inactivate {
		box-shadow: 5px 0px 0px 0px ${colors.greyscale.dark_grey} inset !important;
		color: ${colors.greyscale.grey} !important;

		.btn-link {
			color: ${colors.greyscale.grey} !important;
		}
	}

	.p-inactivate-manager {
		box-shadow: none !important;
		color: ${colors.greyscale.grey} !important;

		.btn-link {
			color: ${colors.greyscale.grey} !important;
		}
	}

	.sm-visible {
		display: table-cell;
	}

	.item-title-span {
		display: inline-block;
		margin-bottom: -8px;

		max-width: 280px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	@media screen and (max-width: 40em) {
		.sm-invisible {
			display: none;
		}

		.sm-text {
			width: 60% !important;
		}

		.sm-actions {
			width: 10% !important;
		}

		.sm-visible {
			display: none;
			margin-right: 0.5rem;
		}
	}
`;
